import { render, staticRenderFns } from "./NewSupport.vue?vue&type=template&id=309b1d58&scoped=true&"
import script from "./NewSupport.vue?vue&type=script&lang=js&"
export * from "./NewSupport.vue?vue&type=script&lang=js&"
import style0 from "./NewSupport.vue?vue&type=style&index=0&id=309b1d58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309b1d58",
  null
  
)

export default component.exports